export const domainName = "https://zongstartalks.com.pk";

export const baseUrl = `${domainName}/startalk/api/`;

export const username = "zstUserId";
export const password = "zstS8dadj#32fskjf39034";

export const gtmId = "GTM-KKDZKHTL";
